import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Home, ChevronRight } from "lucide-react";
import { PropertyCard } from "@/components/PropertyCard";

export function PropertiesGrid({ logements, searchFilters, setSearchFilters }) {
  return (
    <section id="logements-grid" className="py-16 bg-[#F5F0EB]" data-testid="logements-grid-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl text-[#004333] mb-3">Nos derniers logements</h2>
          <p className="text-[#6B5E50] max-w-xl mx-auto">
            Découvrez nos 4 dernières nouveautés à Limoges et ses environs.
          </p>
        </div>

        {logements.length > 0 ? (
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-7">
            {logements.map((logement, index) => (
              <motion.div
                key={logement.id}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.08, duration: 0.5 }}
              >
                <PropertyCard logement={logement} index={index} />
              </motion.div>
            ))}
          </div>
        ) : (
          <div className="text-center py-16 text-gray-500">
            <Home className="w-12 h-12 mx-auto mb-4 text-gray-300" />
            <p>Aucun logement ne correspond a vos critères.</p>
            <button
              onClick={() => setSearchFilters({ ville: "", type_logement: "", capacite_min: "" })}
              className="mt-4 text-[#C9922A] font-medium hover:underline"
            >
              Réinitialiser les filtres
            </button>
          </div>
        )}

        <div className="text-center mt-10">
          <Link to="/voyageurs" className="btn-secondary inline-flex items-center gap-2">
            Voir tous les logements <ChevronRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}
